import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthPageLogoutComponent } from './components/pages/logout/logout.component';
import { AuthPageRedirectionComponent } from './components/pages/redirection/redirection.component';
import { AuthPageWaitingComponent } from './components/pages/waiting/waiting.component';

const routes: Routes = [
  {
    path: 'waiting',
    component: AuthPageWaitingComponent,
  },
  {
    path: 'redirection',
    component: AuthPageRedirectionComponent,
  },
  {
    path: 'logout',
    component: AuthPageLogoutComponent,
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
